import type { AdditionalUserInfo } from 'firebase/auth'
import { UserProfileInput } from 'types/graphql'

/**
 * In most cases, there's a lot more profile data returned from the providers.
 * These interfaces represent a condensed list of the values which we may be interested in.
 */

interface GoogleProfileData {
  email: string
  given_name?: string
  family_name?: string
  gender?: string
  locale?: string
  name?: string
  picture?: string
  verified_email: boolean
}

interface TwitterProfileData {
  email?: string
  location?: string
  name?: string
  profile_image_url_https?: string
  description?: string
  verified: boolean
  screen_name: string
}

export const mapProviderDataToProfileInput = (providerData: AdditionalUserInfo): UserProfileInput | null => {
  switch (providerData.providerId) {
    case 'google.com':
      const googleProfile = providerData.profile as unknown as GoogleProfileData
      return {
        firstName: googleProfile.given_name ?? '',
        lastName: googleProfile.family_name ?? ''
      }

    case 'twitter.com':
      const twitterProfile = providerData.profile as unknown as TwitterProfileData
      const fullName = twitterProfile.name ?? ''

      // Attempt to split a full name into first and last. So 'Jane Doe' would be 'Jane' and 'Doe' but
      // 'Jane Elizabeth Doe' would be 'Jane' 'Elizabeth Doe'. 🤷‍♂️
      return {
        firstName: fullName.split(' ')[0],
        lastName: fullName
          .split(' ')
          .filter((_, index) => index !== 0)
          .join(' '),
        location: twitterProfile.location,
        bio: twitterProfile.description,
        socialAccounts: {
          twitterUsername: `@${twitterProfile.screen_name}`
        }
      }

    default:
      return null
  }
}
